import { render, staticRenderFns } from "./addfictitiouscard.vue?vue&type=template&id=2af05770&scoped=true&"
import script from "./addfictitiouscard.vue?vue&type=script&lang=js&"
export * from "./addfictitiouscard.vue?vue&type=script&lang=js&"
import style0 from "./addfictitiouscard.vue?vue&type=style&index=0&id=2af05770&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af05770",
  null
  
)

export default component.exports